import { useCallback } from "react";

import { useDialogsProvider } from "2g-dialogs-provider";
import ZpracDialog from "2g-zprac-dialog";

import { DATA } from "b2b/api";

import useMessages from "../i18n/useMessages";

export default function useDelete({ id, onSuccess }) {
  const { deleteDialogTitle, deleteDialogConfrimMesage } = useMessages();
  const { showDialog, hideDialog } = useDialogsProvider();

  const handleSuccess = useCallback(() => {
    hideDialog();
    onSuccess();
  }, [hideDialog]);

  return useCallback(() => {
    showDialog(ZpracDialog, {
      url: DATA.provozniInformace(id),
      method: "delete",
      title: deleteDialogTitle(),
      confirmMessage: deleteDialogConfrimMesage(),
      onSuccess: handleSuccess,
      onClose: hideDialog
    });
  }, [
    id,
    showDialog,
    hideDialog,
    deleteDialogTitle,
    deleteDialogConfrimMesage,
    handleSuccess
  ]);
}
